import {
  TaskGroup,
  WebSocketAction,
  WebSocketEntityType,
} from '@this+that/models';
import log from 'loglevel';

import {
  resolveSyncAction,
  SyncAction,
  taskGroupBelongsToActiveTeam,
} from './taskSyncActions';
import { useEntitySync } from './useEntitySync';
import { useFetchTaskGroups } from '../../../hooks/taskGroups/useFetchTaskGroups';
import { useInboxEntriesStore } from '../../../store';
import { useActiveTeamId } from '../../../store/Team/useTeamStore';

export function useTaskGroupsSync() {
  const activeTeamId = useActiveTeamId();
  const createTaskGroup = useInboxEntriesStore(
    (s) => s.taskManager.taskGroups.createTaskGroup,
  );
  const updateTaskGroup = useInboxEntriesStore(
    (s) => s.taskManager.taskGroups.updateTaskGroup,
  );
  const removeTaskGroup = useInboxEntriesStore(
    (s) => s.taskManager.taskGroups.removeTaskGroup,
  );
  const { refetchForActiveTeam } = useFetchTaskGroups();

  const apply = (event: WebSocketAction, item: TaskGroup) => {
    const taskGroup = useInboxEntriesStore
      .getState()
      .taskManager.taskGroups.taskGroups.find((tg) => tg.id === item.id);
    const belongs = taskGroupBelongsToActiveTeam(item, activeTeamId);
    const syncAction = resolveSyncAction(event, {
      exists: !!taskGroup,
      belongs,
    });
    switch (syncAction) {
      case SyncAction.CREATE:
        createTaskGroup(item);
        break;
      case SyncAction.UPDATE:
        updateTaskGroup(item);
        break;
      case SyncAction.REMOVE:
        removeTaskGroup(item.id);
        break;
      default:
        break;
    }
  };

  useEntitySync<TaskGroup>(WebSocketEntityType.TaskGroup, {
    onInsert: (item) => apply(WebSocketAction.INSERT, item),
    onModify: (item) => apply(WebSocketAction.MODIFY, item),
    onRemove: (item) => apply(WebSocketAction.REMOVE, item),
    onReconnect: async () => {
      log.info(
        '[TaskGroupsSync] Reconnected after long pause, refetching task groups',
      );
      try {
        await refetchForActiveTeam();
      } catch (error) {
        log.error('[TaskGroupsSync] Failed to refetch task groups:', error);
      }
    },
  });
}
